<app-header></app-header>
<div class="container-fluid text-light">
    <table datatable class="table">
    <thead>
      <tr>
        <th *ngFor = "let column of headers">
          {{column}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor = "let row of rows" [routerLink]="['/profile', row.Id]">
        <ng-container *ngFor = "let column of headers">
          <td *ngIf="column.toLowerCase()!='date'"> {{row[column]}} </td>
          <td *ngIf="column.toLowerCase()=='date'"> {{row[column]|date:"yyyy-MM-dd"}} </td>
        </ng-container>
      </tr>    
    </tbody>
  </table>
</div>
